angular.module('mercury.modules.reports.reconciliations')
.controller('ReportsReconciliationTenderSurchargesCtrl', ["$filter", "PosTenders", "reporttime", "$scope", "title", function($filter, PosTenders, reporttime, $scope, title) {
  title.set('Tender Surcharges');

  $scope.tenderSurchargeCols = [
    {label: 'Tender Surcharge', type: 'string', key: 'tenderSurchargeName'},
    {label: 'Amount', type: 'number', key: 'tenderSurchargeAmount', filter: 'currency'}
  ];

  $scope.loading = PosTenders.getSurcharges(reporttime.start(), reporttime.end());

  $scope.showTotalsTable = reporttime.reportType() !== 'day';

  $scope.loading.then(function(results) {
    $scope.tenderSurcharges = results;

    $scope.times = [];
    for (var iter = moment(reporttime.start()); iter.isBefore(reporttime.end()); iter.add(1, 'day')) {
      var dayTenderSurcharges = $filter('filter')(results, {startTime: iter.format()});

      var day = {
        startTime: iter.format(),
        totalTenderSurcharges: $filter('sumof')(dayTenderSurcharges, 'tenderSurchargeAmount'),
        tenderSurcharges: dayTenderSurcharges
      };

      $scope.times.push(day);
    }

    var tenderSurchargeTotals = {};
    var totalTenderSurchargeAmount = 0;
    angular.forEach(results, function(ts) {

      if (tenderSurchargeTotals[ts.tenderSurchargePosIdentifier]) {
        tenderSurchargeTotals[ts.tenderSurchargePosIdentifier].tenderSurchargeAmount += ts.tenderSurchargeAmount;
      } else {
        tenderSurchargeTotals[ts.tenderSurchargePosIdentifier] = {
          tenderSurchargeName: ts.tenderSurchargeName,
          tenderSurchargeAmount: ts.tenderSurchargeAmount
        };
      }

      totalTenderSurchargeAmount += ts.tenderSurchargeAmount;
    });

    $scope.totalTenderSurchargeAmount = totalTenderSurchargeAmount;
    $scope.tenderSurchargeTotals = Object.values(tenderSurchargeTotals);
  });
}]);
